import React from "react";
import RoundVoteBreakdownChart from "../VoteCharts/RoundVoteBreakdownChart";
import { getPlayerVotesByRound } from "./playerRoundVotes";

const ROUND_COUNT = 25; // rounds 0..24

const PlayerRoundVoteBreakdown = ({ player, gameVoteData, enabledKeys = [] }) => {
  if (!player || !gameVoteData) return null;

  const playerVotes = getPlayerVotesByRound(player, gameVoteData, enabledKeys);
  // Always show rounds 0..24 sequentially
  const values = Array.from({ length: ROUND_COUNT }, (_, r) => playerVotes[String(r)] || 0);
  const totalVotes = values.reduce((sum, v) => sum + v, 0);

  return (
    <div className="bg-slate-950/60 rounded-xl border border-slate-800 p-3 sm:p-4">
      <RoundVoteBreakdownChart values={values} scaleMax={3} ariaLabel="Player votes by round" />

      {/* Total Row */}
      <div className="mt-3 pt-3 border-t border-slate-800/70">
        <div className="flex items-center justify-between px-1">
          <span className="text-[10px] font-mono uppercase tracking-[0.14em] text-slate-500">Total</span>
          <span className="text-emerald-300 font-mono font-bold tabular-nums text-sm">{totalVotes.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default PlayerRoundVoteBreakdown;
